export default {
  Global_AssetTagging_Selected_Pill: 'Global_AssetTagging_Selected_Pill',
  Global_AssetTagging_Unselected_Pill: 'Global_AssetTagging_Unselected_Pill',
  Global_AssetTagging_Typed_Tag: 'Global_AssetTagging_Typed_Tag',
  Global_AssetTagging_Clicked_SaveTagButton: 'Global_AssetTagging_Clicked_SaveTagButton',
  Global_AssetTagging_Clicked_CreateNewTagButton: 'Global_AssetTagging_Clicked_CreateNewTagButton',
  Global_AssetTagging_Hovered_HelpIcon: 'Global_AssetTagging_Hovered_HelpIcon'
}
